
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './BookingList.html?raw';
import "../BookingList/BookingListTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import '../../../moreCore/UI/StaticTable/StaticTable';
import { EvBookingEditor, EvBookingView, EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import BookingReportOptionsForm from '../BookingReportOptionsForm/BookingReportOptionsForm';
class BookingList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    

    viewContainer: HTMLElement; // will be passed as a function parameter
    tableContainer: HTMLElement; // will be passed as a function parameter
    resultContainer: HTMLDivElement;
    project: VAM2types.EvProjectEntity_Base = null;
    tabContainerName: string = "";

    private btnNewBooking: HTMLButtonElement;
    private btnReloadPage: HTMLButtonElement;

    private editingEnabled: boolean = false;
    private cloningEnabled: boolean = false;
    private entitylistData: Array<VAM2types.EvBooking_Base>;
    private editableEntities: Array<string> | true = [];

    private tableLayout: StaticTable.Layout;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    loadData(project: VAM2types.EvProjectEntity_Base = null) {

        this.StandbyStart(this.tableContainer);

        //DEACTIVATED BECAUSE NOT USED ANYMORE AND REQUEST IS TOO LARGE
        //this.webPrivilegeManager.getWhitelist("EvBooking_Edit",
        //    VAMclassNames.ev_booking,
        //    lang.hitch(this, this._onGetEditableWhitelist));

        if (project) {
            this.project = project;
        }

        if (this.project == null) return;

        this.webPrivilegeManager.loadPrivilegesForEntity(this.project, lang.hitch(this, this._onProjectPrivileges));

        
        let projectId = this.project.ID;

        this.RequestManager.callfunction(
            "Webtool_API_ProjectWizard__GetEvBookingTable",
            { projectId: projectId },
            lang.hitch(this, this._onGetDataResponse),
            lang.hitch(this, this._onGetDataError),
            false // sync
        );


    }
    private _onGetDataResponse(response: more.PackedEntitylistResult<VAM2types.EvBooking_Base>) {

        this.entitylistData = response.entitylist;

        // temporäres Fix: Aktionsspalte wird abgelöst durch Aktionsbuttons
        // falls das Backend trotzdem noch eine actions-Spalte mitschickt, diese hier rausnehmen
        let layout = response.layouts[0];
        for (let row of layout.rows) {
            let index = -1;
            for (let col of row.colNamesInternal) {
                index++;
                if (col == "actions") {
                    if (row.alignmentsHeading?.length > index) row.alignmentsHeading.splice(index, 1);
                    if (row.alignmentsRow?.length > index) row.alignmentsRow.splice(index, 1);
                    if (row.colspans?.length > index) row.colspans.splice(index, 1);
                    if (row.attributes?.length > index) row.attributes.splice(index, 1);
                    if (row.bgColors?.length > index) row.bgColors.splice(index, 1);
                    if (row.txtColors?.length > index) row.txtColors.splice(index, 1);
                    if (row.headingColorsBG?.length > index) row.headingColorsBG.splice(index, 1);
                    if (row.headingColorsTXT?.length > index) row.headingColorsTXT.splice(index, 1);
                    if (row.headings?.length > index) row.headings.splice(index, 1);
                    if (row.widths?.length > index) row.widths.splice(index, 1);

                    row.colNamesInternal.splice(index, 1);
                    break;
                }
            }
        }

        this.tableLayout = response.layouts[0];

        this.drawTable();

        this.emit("loaded");
      
        this.StandbyStop();
    }

    private _onGetEditableWhitelist(whitelist: Array<string> | true) {
       this.editableEntities = whitelist;

        this.drawTable();
    }


    private _onClick_reloadData() {
        if (this.project) {
            this.loadData(this.project)
        } else {
            alert("no projectId!")
        }
    }


    private _onGetDataError(err: more.requestErrorMessage) {
        alert("ERROR beim _onGetDataError: " + err.Message);
    }

    getEntityListData(): Array<VAM2types.EvBooking_Base> {
        return this.entitylistData;
    }
    
    private projectTable_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.EvBooking_Base>) { // formatter
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        let icon;
        switch (colName) {
            
            case "actions":
               
                return true;
                break;
            default:
                if (value == null || value == "" || typeof value == "undefined") {
                    value = "N.A.";
                    node.innerHTML = value;
                    return true;
                }
                break;
        }

        return false;
    }
    cloneBooking(entity: VAM2types.EvBooking_Base, evt?: MouseEvent) {
        //console.debug("cloneBooking", entity);

        if (!this.hasUserRole(["EvBooking_Edit", "EvBooking_Create"], null, this.project)) return;

        if (evt?.stopPropagation) evt.stopPropagation();

        // Generationenkonflikt: VAM sagt das date ist ein String, VAM2 sagt, das date ist ein Date
        // die neue Copyform will Typ 2. je nachdem woher wir kommen könnte es beides sein.
        // sicherheitshalber string-dates mal vorher umwandeln:

        if (typeof (entity.date_start) == "string") {
            (<any>entity).date_start = new Date(entity.date_start);
        }
        if (typeof (entity.date_end) == "string") {
            (<any>entity).date_end = new Date(entity.date_end);
        }

        let cloneForm = new EvBookingCopyForm();
        cloneForm.setup(entity);

        cloneForm.on("saved", lang.hitch(this, this._onSavedClone));
    }

    private _onSavedClone(entityID: string) {
        // mich neu laden
        this.loadData();
    }

    getBookingReport(entity: VAM2types.EvBooking_Base, node: any, evt?: MouseEvent) {
        if (evt) {
            evt.stopPropagation();
        }
        this.StandbyStart(node);
        let url = window.appRoot + "Downloads/BookingReport";
        if (this.hasFeature("EvBooking/BookingReportOptions") === true) {

            let optionsDlg = new BookingReportOptionsForm();
            optionsDlg.displayOptionsDialog(url, entity.ID, lang.hitch(this, this._sendReportRequest));
            optionsDlg.on("bookingreport_cancelled", () => { this.StandbyStop(); });
            return;
        }

        let data = { "bookingID": entity.ID };
        let stringData = JSON.stringify(data);

        this._sendReportRequest(url, stringData);
    }

    private _sendReportRequest(url: string, stringData: string): void {

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );
    }

    private _onDownloadReady(entity: FileFinder.FileDescriptor) {
        //debugger;
        this.StandbyStop();
        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
            entity.downloadKey,
            entity.filename,
            entity.extension);

    }

    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<VAM2types.EvBooking_Base>,
        rowGroup: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>,
        evt) {
        let entity = row.rowGroup.entity;
        let node = row.node;

        this.openViewer(entity, evt);

    //    if (this.editingEnabled) {
    //        this.StandbyStart(node);
    //        this.hasUserRole("EvBooking_Edit", lang.hitch(this, this._onEditorPrivilegeLoaded, entity), entity);
    //    } else {
    //        this.openViewer(entity, evt);
    //    }
    }

    private _onEditorPrivilegeLoaded(entity: VAM2types.EvBooking_Base, result: boolean) {
        
        this.StandbyStop();
        if (result === true) {
            this.openEditor(entity);
        } else {
            this.openViewer(entity);
        }        
    }

    private _rowAction_Edit(data: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>) {
        this.openEditor(data.entity);
    }
    private _rowAction_View(data: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>) {
        this.openViewer(data.entity);
    }
    private _rowAction_Clone(data: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>, evt?) {
        this.cloneBooking(data.entity, evt);
    }
    private _rowAction_BookingReport(data: StaticTable.StaticTableRowGroup<VAM2types.EvBooking_Base>) {
        this.getBookingReport(data.entity, data.rows[0].node);
    }

    private getOpenBookingById(entityId: string): any {
        let openIndex: number = -1;
        for (let index = 0; index < this.openedBookings.length; index++) {
            let openBooking = this.openedBookings[index];

            if (openBooking.entityID == entityId) {
                if (window.tabManager) {
                    if (window.tabManager.getExistingTab(entityId) == null) {

                    } else {
                        openIndex = index;
                        return this.openedBookings[openIndex];
                    }
                } else {
                    openIndex = index;
                    return this.openedBookings[openIndex];
                }
                break;
            }
        }

        return null;
    }
    private openedBookings: Array<{ entityID: string, form: any}>;
    openEditor(data: VAM2types.EvBooking_Base, evt?: MouseEvent) {
        if (evt) {
            evt.stopPropagation();
        }
        let label = this.translations["BookingEditor__CreateNewBooking"];
        let heading = this.translations["General_Label_EvBookings"];
        let GUID = (Math.random() * 100000).toString();

        this.tabContainerName = this.getTabContainerName();

        let editor: MdsLax<InstanceType<typeof EvBookingEditor>> = null; 
        
        if (data) {
            label = data.ev_booking_name;
            GUID = data.ID;
        } else {

        }

        let openBooking = this.getOpenBookingById(GUID);

        if (openBooking) {
            editor = openBooking.form;
        } else {
            editor = new EvBookingEditor();
        }

       

        if (this.tabContainerName && !openBooking) {
            this.createNewTabbedContent({
                enableClosing: true,
                label: label,
                groupLabel: heading,
                widget: editor,
                iconclass: "fas fa-edit",
                name: GUID,
                sidebarEntryName: GUID,
                targetContainerName: this.tabContainerName
            }, true);

            editor.on("tabClosed", lang.hitch(this, this._onBookingClosed, GUID));
        }       

        editor.on("entityDeleted", lang.hitch(this, this.loadData, this.project));
        editor.on("saved", lang.hitch(this, this.loadData, this.project));
        editor.on("closed", lang.hitch(this, this._onBookingClosed, GUID));

        if (!openBooking) {
            this.openedBookings.push({
                entityID: GUID,
                form: editor
            });

            if (data) {
                editor.loadEntityById(data.ID);
            } else {
                editor.setAttributeValue("has_project", true);
                editor.setStartupState("ready");
                editor.setAttributeValue("ref_ev_project", this.project);
            }

            editor.startup();

        } else {
            this.requestTabSwitchGlobal(GUID);
        }

        if (data) {
        } else {
            //let fakeData: Partial<VAM2types.EvBooking_Base> = {
            //    ref_ev_project: this.project,
            //}
            
            editor.setAttributeValue("ref_ev_project", this.project);
            if (this.hasFeature("EvBooking/LoadDefaultValues")) editor.loadDefaultValues(this.project);
        }


    }

   
    openViewer(data: VAM2types.EvBooking_Base, evt?: MouseEvent) {

        if (evt) {
            evt.stopPropagation();
        }

        let bookingId = data.ID
        let form: MdsLax<InstanceType<typeof EvBookingView>> = null;
        let openBooking = this.getOpenBookingById(bookingId);

        if (openBooking) {
            this.tabContainerName = this.getTabContainerName();
            let tab = window.tabManager.getExistingTab(bookingId);
            if (!tab) {
                this._onBookingClosed(bookingId);
                openBooking = null;
            }
        }

        if (!openBooking) {
            form = new EvBookingView();
            this.openedBookings.push({
                entityID: bookingId,
                form: form
            });
        } else {
            form = openBooking.form;
        }


        //if (!openBooking && this.tabContainerName) {
        //    this.requestNewTabbedContentGlobal({
        //        enableClosing: true,
        //        label: data.ev_booking_name,
        //        widget: form,
        //        iconclass: "fas fa-calendar",
        //        name: data.ID,
        //        heading: this.translations["General_Label_EvBookings"],
        //        sidebarEntryName: data.ID,
        //        targetContainerName: this.tabContainerName
        //    }, true);

        //    form.on("tabClosed", lang.hitch(this, this._onBookingClosed, data.ID));
        //}

        if (!openBooking) {
            //form.setup(bookingId, data.ev_booking_name);
            form.showAsDlg(bookingId, data.ev_booking_name, this.getTabContainerName(), data.ref_ev_project.$Displayname);
            form.startup();

            form.on("cloned", lang.hitch(this, this._onSavedClone, data.ID));
            form.on("closed", lang.hitch(this, this._onBookingClosed, data.ID));
            form.on("deleted", lang.hitch(this, this._onBookingDeleted, data.ID));
        } else {
            this.requestTabSwitchGlobal(data.ID);
        }
    }

    private _onBookingDeleted(ID: string) {
        // mich neu laden
        this.loadData();
    }
     private _onBookingClosed(name: string) {
        for (let i = 0; i < this.openedBookings.length; i++) {
            if (name == this.openedBookings[i].entityID) {
                this.openedBookings.splice(i, 1);
                break;
            }
        }
    }

    private _onClick_newBooking(evt) {
        this.openEditor(null, evt);
    }

    private _rowActionEnabled_Edit(entity: VAM2types.EvBooking_Base) {
        let result = this.editableEntities == true || this.editableEntities.indexOf(entity.ID) != -1; // this.webPrivilegeManager.checkEntityPrivilege("EvBooking_Edit", entity.Classname, entity.ID, null);
        return result;
    }

    // was wollen wir mit den FilterDaten anstellen
    drawTable(): void {

        this.UiModder.domConstruct.empty(this.resultContainer);

        if (!this.tableLayout) return;

        let table = new StaticTable();
        this.table = table;
        
        //table.addDefaultRowActionButton("edit", lang.hitch(this, this._rowAction_Edit), lang.hitch(this, this._rowActionEnabled_Edit));
        //table.addDefaultRowActionButton("view", lang.hitch(this, this._rowAction_View));


        //if (this.hasFeature("EvBooking/Copy")) {
        //    table.addCustomRowActionButton("clone",
        //        lang.hitch(this, this._rowAction_Clone),
        //        "fas fa-clone",
        //        null,
        //        150,
        //        this.translate("BookingEditor__CopyEvBooking"),
        //        lang.hitch(this, function () {
        //            return this.cloningEnabled;
        //        }),
        //        true);

        //}
        //if (this.hasFeature("EvBooking/BookingReport")) {
        //    table.addCustomRowActionButton("printBookingReport",
        //        lang.hitch(this, this._rowAction_BookingReport),
        //        "fas fa-print",
        //        null,
        //        160,
        //        this.translate("BookingEditor__GetBookingReport"),
        //        true);

        //}
        table.setFormatter(lang.hitch(this, this.projectTable_formatterFunction));

        table.setData(this.entitylistData);
        table.setLayout(this.tableLayout);
        table.setRowClick(lang.hitch(this, this._onClick_Row))

        this.table.setCyAttribute("BookingList");



        //table.placeAt(this.resultContainer)
        this.UiModder.domConstruct.place(table.domNode, this.resultContainer, "first");
    }

    private _handlePrivileges() {

        let enableCreate = this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"], null, this.project);
        this.editingEnabled = this.hasUserRole(["EvBooking_Edit"], null, this.project)
        this.cloningEnabled = this.hasUserRole("EvBooking_Create", null, this.project) && this.hasFeature("EvBooking/Copy");

        if (this.table) {
            //this.table.enableActionButton("clone");
        }
        
        this.hideNode(this.btnNewBooking, !enableCreate);
        this.hideNode(this.btnReloadPage, !this.hasUserRole(["EvBooking_Read"], null, this.project));
    }

    private _onProjectPrivileges() {
        this._handlePrivileges();
    }

    

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.openedBookings = [];

        this.addSubscription("/Tabbing/TabClosed", lang.hitch(this, this._onBookingClosed));

        this.RequestManager.handleAs = "json";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BookingList);